import Logo from './iconWishListMember.svg';

function IconWishListMember() {
	return (
		<Logo className="icon-wishlist-member" />
	);
}

export default IconWishListMember;
